const NAME = "EMPLOYEES_PROCESSES_PAGE";

export default NAME;
